import { createContext, useContext } from 'react';
import type { User } from 'firebase/auth';

export interface AdminUser {
  id: string;
  email: string;
  name: string | null;
  picture: string | null;
  roles: string[];
}

export type AuthStatus =
  | 'loading'
  | 'unauthenticated'
  | 'authenticated'
  | 'forbidden';

export interface AuthContextValue {
  status: AuthStatus;
  user: AdminUser | null;
  firebaseUser: User | null;
  error: string | null;
  signIn: () => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
